<template>
  <empty-layout>
    <div
      class="w-full h-full flex justify-center text-black font-proxima-nova"
      :class="{ '!pt-[60px]': isIos }"
    >
      <div v-html="accessDenied.htmlPage"></div>
      <div class="mx-auto w-[327px] md:w-[702px] absolute bottom-[64px]">
        <div class="cursor-pointer w-max flex gap-2 my-6 mx-auto" @click="logoutUser">
          <img class="w-[24px] h-[24px]" src="/assets/icons/logout-black.svg" alt="Log Out" />
          <p class="text-[16px] font-[400] leading-[20px] font-aktiv-grotesk">Log Out</p>
        </div>
      </div>
    </div>
  </empty-layout>
</template>

<script>
import EmptyLayout from '@/components/EmptyLayout.vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { Browser } from '@capacitor/browser';
import platformMixin from '@/mixins/platformMixin';
import axios from 'axios';
import { createLogoutUri } from '@/utils/redirect-uri';
export default {
  name: 'access-denied',
  mixins: [platformMixin],
  components: { EmptyLayout },
  data() {
    const { logout } = useAuth0();
    return {
      logout,
      accessDenied: {
        htmlPage: '',
      },
    };
  },
  async ionViewDidEnter() {
    await this.fetchCVP();
  },
  methods: {
    async fetchCVP() {
      const { data } = await axios.get(process.env.VUE_APP_API_URL + '/cms/access-denied-page');
      this.accessDenied = data;
    },
    async logoutUser() {
      try {
        const { clearDatadogRumUser } = await import('@/utils/datadog');
        clearDatadogRumUser();
      } catch (e) {
        // non-blocking
      }
      if (process.env.VUE_APP_NODE_ENV === 'local') {
        localStorage.removeItem('token');
        this.$router.push('/login');
      } else {
        await this.logout({
          logoutParams: {
            returnTo: createLogoutUri(
              process.env.VUE_APP_PACKAGE_ID,
              process.env.VUE_APP_AUTH0_DOMAIN,
            ),
          },
          openUrl: async url =>
            await Browser.open({
              url,
              windowName: '_self',
            }),
        });
      }
    },
  },
};
</script>

<style scope></style>
